module.exports = __webpack_public_path__ + "static/img/GH.f65b9fe8.svg";